import { Grid, Toolbar } from '@mui/material'
import React from 'react'
import { Link as RouterLink, useLocation } from 'react-router'
import { HeaderContainer, HeaderLogo } from './styles'

type HeaderProps = {
  isLoggedIn: boolean
}

const Header = (_: HeaderProps) => {
  const location = useLocation()

  const isTop = location.pathname === '/'

  return isTop ? (
    <></>
  ) : (
    <HeaderContainer position="sticky" elevation={2}>
      <Toolbar>
        <Grid
          container
          sx={{
            alignItems: 'center',
          }}>
          <Grid size="grow">
            <RouterLink to="/">
              <HeaderLogo src="/images/logo_light.png" alt="クチヨミ" />
            </RouterLink>
          </Grid>
        </Grid>
      </Toolbar>
    </HeaderContainer>
  )
}

export default Header
